import { render, staticRenderFns } from "./ShopAddress.vue?vue&type=template&id=fac738ce&scoped=true&"
import script from "./ShopAddress.vue?vue&type=script&lang=js&"
export * from "./ShopAddress.vue?vue&type=script&lang=js&"
import style0 from "./ShopAddress.vue?vue&type=style&index=0&id=fac738ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac738ce",
  null
  
)

export default component.exports